import { AlarmItem, Vehicle } from '../../../base/store/state.interface'

export default {
  data() {
    return {
      showRequestSuccessfulMessage: false,
      showRequestSuccessfulMessageDuration: 2000
    }
  },
  computed: {
    alarmedVehicles(): string {
      let result = ''
      const item = this.item as AlarmItem

      if (!item) {
        return result
      }

      const vehicles = this.$store.state.cluster.vehicle

      item.vehicle.forEach(vehicleId => {
        const vehicle = vehicles[vehicleId] as Vehicle
        if (!vehicle) {
          return
        }
        if (result) {
          result += ', '
        }
        result += vehicle.name
      })

      return result
    },
    canAccessReportField() {
      const reportFieldAccess = this.$store.state.user.access.alarm_fields.report
      const item = this.item as AlarmItem
      return reportFieldAccess === 2 || (reportFieldAccess === 1 && item.editable)
    },
    canAnswer() {
      return this.item.answerable && this.$store.state.cluster.settings.alarm_response
    },
    isItemAnswerable() {
      const item = this.item as AlarmItem
      const isAnswerable = (this.$parent.firstAlarmId === item.id) || this.$store.state.cluster.settings.alarm_response_multiple
      const isValidAnswerTimeframe = ((item.response_time === 0) && !item.closed) || ((item.response_time > 0) && (item.ts_response > this.now()))
      return isAnswerable && isValidAnswerTimeframe
    },
    statusOptions() {
      return this.$store.state.cluster.statussorting_alarm
    },
    availableStatus() {
      const cluster = this.$store.state.cluster
      const sorting = cluster.statussorting_alarm
      const allStatus = cluster.status
      const result: any[] = []

      sorting.forEach(statusId => {
        const status = allStatus[statusId]
        if (!status) {
          return
        }
        result.push(status)
      })

      return result
    }
  },
  methods: {
    async sendAlarmNote() {
      const input = this.$refs['ref-alarm-note']

      if (!input) {
        return
      }

      const item = this.item

      await this.$store.dispatch('saveAlarmStatus', {
        alarmID: item.id,
        statusID: item.ucr_self_status_id || 0,
        customAnswer: input.value
      })

      this.showRequestSuccessfulMessage = true
      window.setTimeout(() => this.showRequestSuccessfulMessage = false, this.showRequestSuccessfulMessageDuration)
    },
    async setAlarmStatus(statusID) {
      const item = this.item
      await this.$store.dispatch('saveAlarmStatus', {
        alarmID: item.id,
        statusID: statusID,
        customAnswer: item.ucr_self_note
      })
    }
  }
}
